export const isEscape = (e: KeyboardEvent) => e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;

export const isSpace = (e: KeyboardEvent) => e.key === 'Space' || e.keyCode === 32 || e.key === ' ';

export const isEnter = (e: KeyboardEvent) => e.key === 'Enter' || e.keyCode === 13;

export const isLeftKey = (e: KeyboardEvent) => e.key === 'ArrowLeft' || e.keyCode === 37;

export const isRightKey = (e: KeyboardEvent) => e.key === 'ArrowRight' || e.keyCode === 39;
